import { createReducer, on } from '@ngrx/store';
import { fromIndividualsAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IIndividualsResponse } from '../models/individuals.model';

export const individualsFeatureKey = 'individuals';

export interface IndividualsState {
  individualsResponse: IIndividualsResponse[];
  individualsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: IndividualsState = {
  individualsFailure: undefined,
  individualsResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromIndividualsAction.getIndividualsRequest, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromIndividualsAction.getIndividualsResponse, (state, action) => ({
    ...state,
    individualsResponse: action.response
  })),

  on(fromIndividualsAction.getIndividualsFailure, (state, action) => ({
    ...state,
    individualsFailure: action.error
  }))
);

export const getIndividualsResponse = (state: IndividualsState) => state.individualsResponse;
export const getIndividualsFailure = (state: IndividualsState) => state.individualsFailure;
export const getIndividualsIsLoaded = (state: IndividualsState) => state.loaded;
